import React from "react";
import { AppBar, Typography } from "@mui/material";
import Labels from "../labels/Labels";

export default function Footer() {
  // Get the label and replace year placeholder
  const copyrightText = Labels.getLabel(
    "footer.copyright",
    "© Copyright {0} | Rellevate. Inc."
  ).replace("{0}", new Date().getFullYear());

  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{ top: "auto", bottom: 0, padding: 1, margin: 0 }}
    >
      <Typography variant="body1" align="center" sx={{ fontSize: "15px" }}>
        {copyrightText}
      </Typography>
    </AppBar>
  );
}
